import React from "react"
import Button from './common/Link'

const TesteGratis = () => <Button target="__blank" link="https://tagplus.com.br/?ref=landing_beta">Experimente grátis <i className='far fa-thumbs-up'></i></Button>
export default TesteGratis
